// components/SEO.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, keywords }) => {
  const siteTitle = 'Zia Dental Care';
  const defaultDescription = 'Professional dental care in Topi, Swabi – general dentistry, implants, orthodontics, root canals & cosmetic dentistry. Book your appointment today!';
  const defaultKeywords = 'dentist Topi, dental clinic Swabi, Zia Dental Care, dental implants, orthodontics KPK, root canal treatment, best dentist Swabi, family dentist Pakistan';
  const siteBaseUrl = 'https://www.ziadentalcare.com';
  const ogImage = `${siteBaseUrl}/images/hero/dental-clinic-1.jpg`;

  const metaDescription = description || defaultDescription;
  const metaKeywords = keywords || defaultKeywords;
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const location = useLocation();
  const canonicalUrl = `${siteBaseUrl}${location.pathname === '/' ? '' : location.pathname}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:image" content={ogImage} />

      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content={siteTitle} />
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default SEO;